// Global search over the searchable, visible columns.

import { productLocale, searchTexts } from '../format'

export const isSearchable = column =>
  column.capabilities
    ? Boolean(column.capabilities.search)
    : Boolean(column.searchable)

export const normalizeSearch = (term, locale) =>
  (term || '').trim().toLocaleLowerCase(productLocale(locale))

// Trimmed, case-insensitive substring; diacritics and internal whitespace are literal. A hidden column is
// not searched.
export const matchesSearch = (row, columns, term, locale, hidden = []) => {
  const loc = productLocale(locale)
  const needle = normalizeSearch(term, loc)
  if (!needle) return true
  return columns
    .filter(column => isSearchable(column) && !hidden.includes(column.key))
    .some(column =>
      searchTexts(column, row, loc).some(text =>
        String(text).toLocaleLowerCase(loc).includes(needle)
      )
    )
}
